export const pressItems = [
  {
    id: "p1",
    title:
      "Voltage Teeing Off Sales At TIFF For Madelaine Petsch Romantic Comedy 'I Wish I Never Had Sex With Him'",
    date: "2026-09-01",
    source: "Deadline",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/media%2FScreenshot+2026-09-01+at+3.06.02%E2%80%AFPM_%7B7d40daf3-50a6-f111-82ac-0e4a64f8a357%7D.png",
  },
  {
    id: "p2",
    title:
      "Daisy Ridley-Alden Ehrenreich Rom-Com 'The Last Resort' Heads To Cannes Market With Voltage; Vertical Checks In For U.S. Rights",
    date: "2026-05-05",
    source: "Deadline",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/media%2FLR+Deadline+Blast+image_%7Bfc64e569-3ec8-40ec-abfb-b9dfec689944%7D.png",
  },
  {
    id: "p3",
    title:
      "Voltage Pictures has taken international rights to romantic comedy So Much for Love",
    date: "2025-11-10",
    source: "Screen Daily",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/media%2FScreenshot+2025-11-19+at+2.50.55%E2%80%AFPM_%7B6d03ceea-9ac5-f011-82a9-0e4a64f8a357%7D.png",
  },
  {
    id: "p4",
    title: "Voltage Pictures Takes Foreign on Slasher 'THE HIM'",
    date: "2025-09-25",
    source: "Variety",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/media%2FScreenshot+2025-10-16+at+3.30.28%E2%80%AFPM_%7B2d7eb94d-dfaa-f011-82a9-0e4a64f8a357%7D.png",
  },
  {
    id: "p5",
    title:
      "Voltage Pictures will launch worldwide sales at EFM next month on the action thriller Safe House",
    date: "2025-01-27",
    source: "Deadline",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/media%2FScreenshot+2025-01-27+at+11.41.13%E2%80%AFAM_%7B95f425d3-a0e8-4b07-a6f5-57d049cecd20%7D.png",
  },
  {
    id: "p6",
    title:
      "Voltage Pictures Acquires Majority Stake in International Sales and Finance Company The Exchange",
    date: "2025-01-07",
    source: "Screen Daily",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/media%2FScreenshot+2025-02-19+at+5.32.18%E2%80%AFPM_%7B6f60f66d-4e9e-4add-9922-0bef5f640908%7D.png",
  },
];

export const stats = [
  { value: "1,200+", label: "Films in the library" },
  { value: "120+", label: "Territories worldwide" },
  { value: "20+", label: "Years in global sales" },
  { value: "AFM · EFM · TIFF", label: "Markets every year" },
];